import Lenis from '@studio-freight/lenis'
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CSSPlugin from 'gsap/CSSPlugin';
gsap.registerPlugin(ScrollTrigger, CSSPlugin);
import Swiper from 'swiper';
import { EffectFade } from 'swiper/modules';
Swiper.use([EffectFade]);

const setScrollbarWidth = () => {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	// カスタムプロパティの値を更新する
	document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
};

setScrollbarWidth();


const body = document.querySelector('body');
const btn = document.querySelector('.menuBtn');
const menu_target = document.querySelector('.fixed-menu');
const menu_overlay = document.querySelector('.fixed-menu__overlay');
const hlbtn = document.querySelector('.menuBtn');
const hlbtn__Close = document.querySelector('.fixed-menu__close');
const searchbtn = document.querySelector('.header__search-btn');

const anchorLinks = document.querySelectorAll('a[href^="#"]');
const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
const header = document.querySelector('.header');
const anchorHash = location.hash;

const nowPath = location.pathname;
const headerNavLi = document.querySelectorAll('.header__nav a');

let scrollpos;

function menuOpenAnim(target) {
	hlbtn.setAttribute('aria-expanded', 'true');
	gsap.to(menu_target, {
		ease: "expo.out",
		duration: 0,
		autoAlpha: 1,
		display: "flex"

	});

	scrollpos = window.scrollY;
	body.style.top = scrollpos * -1 + 'px';
	body.classList.add('fixed');
	body.style.paddingRight = window.innerWidth - document.body.clientWidth + 'px';
}
function menuCloseAnim(target) {
	hlbtn.setAttribute('aria-expanded', 'false');

	//menu_target.setAttribute('aria-hidden', 'true');
	gsap.to(menu_target, {
		ease: "expo.out",
		duration: 0,
		autoAlpha: 0,
		display: "none"
	});
	body.classList.remove('fixed');
	body.style.top = 0 + 'px';
	body.style.paddingRight = '0px';
	window.scrollTo(0, scrollpos);
}
function headerActive() {
	headerNavLi.forEach(link => {
		link.removeAttribute('aria-current');
	});
	if( nowPath == "/" ){
		headerNavLi[0].setAttribute('aria-current', 'page');
	}else if( nowPath.match("service") ){
		headerNavLi[1].setAttribute('aria-current', 'page');
	}else if( nowPath.match("service") ){
		headerNavLi[1].setAttribute('aria-current', 'page');
	}
}



headerActive();

window.addEventListener("pageshow", function () {

	//lenis.scrollTo("html", 'duration:0');

	//console.log(lenis);

	if (window.innerWidth < 761) {
		document.querySelector(".fixed-menu .search-box details").open = false;
	}

	//ヘッダーボタン
	hlbtn.addEventListener("click", function () {

		if (hlbtn.getAttribute('aria-expanded') == 'false') {
			menuOpenAnim(this);
		} else {
			menuCloseAnim(this);
		}
	});


	searchbtn.addEventListener("click", function () {
		menuOpenAnim(this);
	});

	//ヘッダーボタン
	hlbtn__Close.addEventListener("click", function () {
		menuCloseAnim(this);
	});
	menu_overlay.addEventListener("click", function () {
		menuCloseAnim(this);
	});

	if (anchorHash) {
		window.scrollTo({
			top: 0,
			behavior: "instant"
		});
		const targetElement = document.querySelector(anchorHash);
		const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
		const headerHeight = header.offsetHeight;
		const totalScrollAmount = targetOffsetTop - headerHeight;

		targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		var tm = 500;
		//setTimeout(fn, tm);
	}
	anchorLinksArr.forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault();
			const targetId = link.hash;
			const targetElement = document.querySelector(targetId);
			const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
			const headerHeight = 0;
			//const totalScrollAmount = targetOffsetTop - headerHeight;
			const totalScrollAmount = targetOffsetTop - headerHeight;
			targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});
	});



	//
	/*
	const viewAnimTarget = document.querySelectorAll('[data-view-cont="true"]');

	viewAnimTarget.forEach((cont) => {
		let viewAnimItem = cont.querySelectorAll('[data-view-item]');
		//let viewAnimItemLength = viewAnimItem.length;

		const viewTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: cont,
				start: "top center",
				//markers:true,
			},
		});

		viewTimeline.fromTo(
			viewAnimItem,
			{
				autoAlpha: 0,
				y: 30
			},
			{
				y: 0,
				autoAlpha: 1,
				duration: .4,
				stagger: {
					each: .1,
				}
			},

		);

		viewAnimItem.forEach((item) => {
			//console.log(item);
		});
	});*/

});
window.addEventListener("resize", function () {
	setScrollbarWidth();
});
